/**
 * =============================================================================
 * fragrance-finder.js 
 * =============================================================================
 *
 * Stub extension populated by the 'fragrance-finder' section.
 * Only used for holding data.
 * =============================================================================
 */

var FragranceFinder = {
  data: {}
}

export default FragranceFinder